var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlobOrangeHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_679_1608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M900 0H0V600H900V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 113.301C47.5 158.001 95 202.701 157.7 219.401C220.3 236.101 298.1 224.801 344.2 255.801C390.3 286.901 404.7 360.301 423.1 424.701C441.6 489.201 464.2 544.601 486.7 600.001H0V113.301Z",
    fill: "#FFECD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 234.9C35.6 268.5 71.3 302 118.2 314.5C165.2 327 223.6 318.6 258.1 341.9C292.7 365.2 303.5 420.2 317.4 468.5C331.2 516.9 348.1 558.4 365.1 600H0V234.9Z",
    fill: "#FFC88E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 356.602C23.8 379.002 47.5 401.302 78.8 409.702C110.2 418.002 149 412.402 172.1 427.902C195.1 443.402 202.3 480.202 211.6 512.402C220.8 544.602 232.1 572.302 243.4 600.002H0V356.602Z",
    fill: "#FFA341"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 478.301C11.9 489.501 23.8 500.701 39.4 504.801C55.1 509.001 74.5 506.201 86 514.001C97.6 521.701 101.2 540.101 105.8 556.201C110.4 572.301 116 586.101 121.7 600.001H0V478.301Z",
    fill: "#FF9100"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_679_1608"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 600,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobOrangeHalf);
export default __webpack_public_path__ + "static/media/blob_orange_half.14ba94c49e6de26d84a04523926d7e8e.svg";
export { ForwardRef as ReactComponent };